/*
 * Kalmix custom code
 * File: assets/kmx-home-correct.js
 * Version: 1008.1
 * History:
 * - 1008.1 Fix state named SINGLE instead of AUTONOMOUS (readout and laptop chip).
 * - 1007.5 Knowledge-dot tips flip to the left on hover / focus when they would
 *   run past the right edge of the viewport.
 * - 1007.4 RTCM packets are readable: one packet per path every second, message
 *   types taking turns, 2.4 s flight with ease-in-out. Grid is offset half a cell
 *   so the (smaller) station stands in the middle of a cell.
 * - 1007.3 Layout: the phone's left edge is placed 72 px right of the heading's
 *   widest line and the rig scales (max 1.15) to fill the space up to the right
 *   edge. Draws the endless isometric grid around the base (fades with distance,
 *   a few virtual-base dots near the station). Packets start at the antenna.
 * - 1007.2 Phone status uses the SCOPE labels (Single / Float / Fixed, pill class
 *   is-single / is-float / is-fixed); elevation shown as "1483.0m". The three steps
 *   in the left column follow the animation (Connect while off, Stream once RTCM
 *   is on, Fix when FIXED). The left column is padded so its heading lines up
 *   with the top of the phone and its buttons with the bottom.
 * - 1007.1 Initial delivery of 03 CORRECT. The SCOPE-style RTCM key toggles
 *   corrections (auto-start ~1 s after the act enters). RTCM packets fly from
 *   the NTRIP base to the phone and the laptop at 1 Hz; after the first one
 *   arrives the fix goes AUTONOMOUS → FLOAT (~4 s) → FIXED, the laptop chip
 *   follows the phone by 0.4 s and the scatter zooms from ±5 m to ±5 cm.
 *   Samples at 5 Hz (simulated around the Four Corners point) drive the phone
 *   coordinates, RMS / CEP50 / CEP95 over the last 60 s and the RMS-over-time
 *   line. Turning RTCM off returns to AUTONOMOUS. Reduced motion shows the
 *   final FIXED state without animation. Mobile shows the phone only.
 */
(function () {
  'use strict';

  function initCorrect(sec) {
    if (sec.__kmxInit) return; sec.__kmxInit = true;
    var KMX = window.KMX || { reduce: false, onEnter: function () {}, onVisible: function () {} };
    var reduce = KMX.reduce;
    var q = function (k) { return sec.querySelector('[data-k="' + k + '"]'); };
    var stage = sec.querySelector('.kmx-cor__stage');
    var rig = sec.querySelector('.kmx-cor__rig');
    var fly = sec.querySelector('.kmx-cor__fly');
    var sc = sec.querySelector('.kmx-cor__sc');
    var spark = sec.querySelector('.kmx-cor__spark');
    var key = sec.querySelector('.kmx-cor__rtcm');
    var phone = sec.querySelector('.kmx-cor__phone');
    var laptop = sec.querySelector('.kmx-cor__laptop');
    var base = sec.querySelector('.kmx-cor__base');
    var mq = window.matchMedia('(max-width: 860px)');

    var LAT = parseFloat(sec.getAttribute('data-lat')) || 36.998977;
    var LON = parseFloat(sec.getAttribute('data-lon')) || -109.045172;
    var ALT = parseFloat(sec.getAttribute('data-alt')) || 1483.1;
    var M_LAT = 1 / 111320, M_LON = 1 / (111320 * Math.cos(LAT * Math.PI / 180));

    /* ---------- 状态 ---------- */
    var on = false, state = 'auto', tOn = 0, tFirst = 0, lastPkt = 0, chipLag = null;
    var bias = { e: 0.9, n: -0.6 }, walk = { e: 0, n: 0 };
    var samples = [];         // {t, e, n, s}
    var rmsHist = [];         // 每秒一个 RMS
    var zoom = 5, zoomTo = 5; // 散点图半幅（米）

    function gauss() { var u = 0; for (var i = 0; i < 6; i++) u += Math.random(); return u - 3; }
    function setState(s) {
      if (state === s) return; state = s; sec.setAttribute('data-state', s);
      var pill = q('pill'), names = { auto: 'Single', float: 'Float', fixed: 'Fixed' };
      pill.textContent = names[s]; pill.className = 'kmx-cor__pill is-' + (s === 'auto' ? 'single' : s);
      steps();
      q('state').textContent = s === 'auto' ? 'SINGLE' : s.toUpperCase();
      clearTimeout(chipLag);
      chipLag = setTimeout(function () {   // 电脑上的视图比手机晚 0.4 s 同步
        var c = q('chip'); c.textContent = s === 'auto' ? 'SINGLE' : s.toUpperCase();
        c.className = 'kmx-cor__chip' + (s === 'auto' ? '' : ' is-' + s);
      }, s === 'auto' ? 0 : 400);
      zoomTo = s === 'fixed' ? 0.05 : 5;
      if (s === 'fixed') sec.classList.add('is-done');
    }
    function setOn(v) {
      on = v; key.setAttribute('aria-pressed', v ? 'true' : 'false');
      key.textContent = v ? key.dataset.stop : key.dataset.start;
      if (v) { tOn = performance.now(); tFirst = 0; lastPkt = 0; packets.length = 0; }
      else { setState('auto'); q('page').textContent = '--'; q('age').textContent = '--'; q('wage').textContent = '--'; }
      steps();
    }
    key.addEventListener('click', function () { setOn(!on); });
    // 知识点：提示卡会超出视口右缘时改为朝左展开
    Array.prototype.forEach.call(sec.querySelectorAll('.kmx-cor__kd'), function (k) {
      function place() {
        var tip = k.querySelector('.kmx-kdot__tip'); if (!tip) return;
        k.classList.remove('is-flip');
        var dot = k.getBoundingClientRect(), w = tip.getBoundingClientRect().width;
        if (dot.right + w + 24 > window.innerWidth) k.classList.add('is-flip');
      }
      k.addEventListener('mouseenter', place); k.addEventListener('focus', place);
    });
    // 左栏三步：未开 RTCM → 01；已开、未固定 → 02；FIXED → 03
    var stepEls = sec.querySelectorAll('.kmx-cor__steps li');
    function steps() {
      var cur = state === 'fixed' ? 3 : on ? 2 : 1;
      for (var i = 0; i < stepEls.length; i++) {
        var n = i + 1; stepEls[i].classList.toggle('is-on', n === cur); stepEls[i].classList.toggle('is-done', n < cur);
      }
    }
    steps();

    /* ---------- 采样（5 Hz） ---------- */
    function sigma(now) {
      if (state === 'fixed') return 0.006;
      if (state === 'float') { var k = Math.min(1, (now - tFirst) / 4000); return 0.55 * Math.pow(0.12, k); }
      return 0.8;
    }
    function sample(now) {
      var s = sigma(now);
      walk.e += gauss() * 0.04; walk.n += gauss() * 0.04; walk.e *= 0.98; walk.n *= 0.98;
      var k = state === 'auto' ? 1 : state === 'float' ? Math.max(0, 1 - (now - tFirst) / 2500) : 0;
      var e = (bias.e + walk.e) * k + gauss() * s, n = (bias.n + walk.n) * k + gauss() * s;
      samples.push({ t: now, e: e, n: n, s: state });
      while (samples.length && now - samples[0].t > 60000) samples.shift();
      // 手机读数
      q('plat').textContent = (LAT + n * M_LAT).toFixed(6) + ' N';
      q('plon').textContent = Math.abs(LON + e * M_LON).toFixed(6) + (LON < 0 ? ' W' : ' E');
      q('palt').textContent = (ALT + gauss() * s * 1.6).toFixed(1) + 'm';
      q('wlat').textContent = (LAT + n * M_LAT).toFixed(6) + ' N';
      q('wlon').textContent = Math.abs(LON + e * M_LON).toFixed(6) + (LON < 0 ? ' W' : ' E');
    }
    function stats() {
      // 只统计当前状态下的样本，读数才会跟着收敛
      var r = samples.filter(function (p) { return p.s === state; }).slice(-120).map(function (p) { return Math.hypot(p.e, p.n); });
      if (r.length < 3) return null;
      var sq = r.reduce(function (a, v) { return a + v * v; }, 0) / r.length;
      r.sort(function (a, b) { return a - b; });
      return { rms: Math.sqrt(sq), c50: r[Math.floor(r.length * .5)], c95: r[Math.min(r.length - 1, Math.floor(r.length * .95))] };
    }
    function fmt(m) { return m.toFixed(3) + ' m'; }

    /* ---------- 画布尺寸与舞台缩放 ---------- */
    function fit(c) { var d = Math.min(window.devicePixelRatio || 1, 2), r = c.getBoundingClientRect(), s = parseFloat(getComputedStyle(rig).getPropertyValue('--rig-s')) || 1;
      var w = c.offsetWidth, h = c.offsetHeight; c.width = Math.max(1, w * d * s); c.height = Math.max(1, h * d * s);
      var x = c.getContext('2d'); x.setTransform(d * s, 0, 0, d * s, 0, 0); return { w: w, h: h, x: x }; }
    var F, S, P, gridC = sec.querySelector('.kmx-cor__grid');
    /* ---------- 网络 RTK 网格：等轴、无限延伸、以基站为中心渐隐 ---------- */
    function drawGrid() {
      var G = fit(gridC), x = G.x, w = G.w, h = G.h;
      var step = 46, k = .5, n = 60;
      // 基站立在一个网格的中心：交点整体上移半格
      var cx = base.offsetLeft + base.offsetWidth / 2 - gridC.offsetLeft, gy = base.offsetTop + 55 - gridC.offsetTop, cy = gy - step / 2;
      x.clearRect(0, 0, w, h);
      x.strokeStyle = 'rgba(124,200,255,.22)'; x.lineWidth = 1; x.beginPath();
      for (var i = -n; i <= n; i++) {
        var o = i * step;   // 两组斜线：y = ±k(x - cx) + cy + o
        x.moveTo(0, cy + o + k * (0 - cx)); x.lineTo(w, cy + o + k * (w - cx));
        x.moveTo(0, cy + o - k * (0 - cx)); x.lineTo(w, cy + o - k * (w - cx));
      }
      x.stroke();
      // 网格节点上的虚拟基站点（靠近基站的几圈）
      x.fillStyle = 'rgba(124,200,255,.55)';
      for (var a = -4; a <= 4; a++) for (var b = -4; b <= 4; b++) {
        if ((a + b) % 2) continue;
        var ux = (a + b) / 2, uy = (b - a) / 2;   // 交点坐标
        var nx = cx + (a - b) * step / (2 * k) / 1, ny = cy + (a + b) * step / 2;
        x.beginPath(); x.arc(nx, ny, 1.4, 0, 7); x.fill();
      }
      // 渐隐：椭圆径向蒙版（等轴视角下纵向压扁）
      x.save(); x.globalCompositeOperation = 'destination-in';
      x.translate(cx, gy); x.scale(1, .55);
      var gr = x.createRadialGradient(0, 0, 0, 0, 0, 720);
      gr.addColorStop(0, 'rgba(0,0,0,1)'); gr.addColorStop(.35, 'rgba(0,0,0,.55)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
      x.fillStyle = gr; x.fillRect(-cx, -gy / .55, w, h / .55);
      x.restore();
    }
    function resize() {
      if (!mq.matches) {
        // 构图：手机左边缘放在标题最宽一行右侧 72 px，舞台按剩余空间缩放
        var r = stage.getBoundingClientRect(), h2 = sec.querySelector('.kmx-cor__h2');
        var rg = document.createRange(); rg.selectNodeContents(h2);
        var tr = 0; Array.prototype.forEach.call(rg.getClientRects(), function (c) { tr = Math.max(tr, c.right); });
        var px = Math.min(Math.max(tr + 72, r.left), r.left + r.width * .2);
        var s = Math.min((r.right - px) / 808, r.height / 610, 1.15);
        s = Math.max(.5, s);
        rig.style.setProperty('--rig-s', s.toFixed(3));
        rig.style.setProperty('--rig-x', (px - r.left - 32 * s).toFixed(1) + 'px');
      } else { rig.style.removeProperty('--rig-s'); rig.style.removeProperty('--rig-x'); }
      F = fit(fly); S = fit(sc); P = fit(spark);
      if (gridC && !mq.matches) drawGrid();
      // 左栏上下留白：标题对齐手机顶边，按钮对齐手机底边
      var copy = sec.querySelector('.kmx-cor__copy');
      if (copy && !mq.matches) {
        copy.style.setProperty('--cor-pt', '0px'); copy.style.setProperty('--cor-pb', '0px');
        var cr = copy.getBoundingClientRect(), pr = phone.getBoundingClientRect();
        copy.style.setProperty('--cor-pt', Math.max(0, pr.top - cr.top) + 'px');
        copy.style.setProperty('--cor-pb', Math.max(0, cr.bottom - pr.bottom) + 'px');
      }
    }
    resize(); window.addEventListener('resize', resize);

    /* ---------- 数据包：基站 → 手机 / 电脑 ---------- */
    var packets = [], seq = 0, TYPES = ['1005', '1074', '1084', '1094', '1124'];
    function ease(t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
    function pt(el, fx, fy) { return { x: el.offsetLeft + el.offsetWidth * fx, y: el.offsetTop + el.offsetHeight * fy }; }
    function drawFly(now) {
      var x = F.x; x.clearRect(0, 0, F.w, F.h);
      if (mq.matches) return;
      var a = pt(base, .5, .15), b = pt(phone, .86, .02), c = pt(laptop, .55, 0);
      var paths = [[a, { x: (a.x + b.x) / 2, y: a.y - 10 }, b], [a, { x: (a.x + c.x) / 2 + 70, y: (a.y + c.y) / 2 }, c]];
      x.setLineDash([3, 5]); x.lineWidth = 1;
      paths.forEach(function (p, i) { x.strokeStyle = on ? 'rgba(124,200,255,.38)' : 'rgba(124,200,255,.12)'; x.beginPath(); x.moveTo(p[0].x, p[0].y); x.quadraticCurveTo(p[1].x, p[1].y, p[2].x, p[2].y); x.stroke(); });
      x.setLineDash([]);
      // 每秒两个报文（手机、电脑各一），类型轮流出现，飞行 2.4 s，看得清编号
      if (on && now - lastPkt > 1000) { lastPkt = now; packets.push({ t0: now, path: 0, type: TYPES[seq % 5] }); packets.push({ t0: now + 500, path: 1, type: TYPES[(seq + 2) % 5] }); seq++; }
      x.font = '500 9.5px "JetBrains Mono", ui-monospace, monospace'; x.textBaseline = 'middle';
      for (var i = packets.length - 1; i >= 0; i--) {
        var k = (now - packets[i].t0) / 2400; if (k < 0) continue;
        if (k >= 1) { if (!tFirst && on) tFirst = now; packets.splice(i, 1); continue; }
        var p = paths[packets[i].path], ke = ease(k), u = 1 - ke;
        var px = u * u * p[0].x + 2 * u * ke * p[1].x + ke * ke * p[2].x, py = u * u * p[0].y + 2 * u * ke * p[1].y + ke * ke * p[2].y;
        var w = x.measureText(packets[i].type).width + 10;
        x.globalAlpha = Math.min(1, k * 8, (1 - k) * 8);
        x.fillStyle = '#7cc8ff'; x.beginPath(); x.roundRect ? x.roundRect(px - w / 2, py - 8, w, 16, 3) : x.rect(px - w / 2, py - 8, w, 16); x.fill();
        x.fillStyle = '#0b1720'; x.fillText(packets[i].type, px - w / 2 + 5, py + .5);
        x.globalAlpha = 1;
      }
    }

    /* ---------- 散点图（四州十字） ---------- */
    function drawScatter() {
      var x = S.x, w = S.w, h = S.h, cx = w / 2, cy = h / 2 + 2, R = Math.min(w, h) / 2 - 14;
      x.clearRect(0, 0, w, h);
      x.strokeStyle = '#eef0f4'; x.lineWidth = 1;
      for (var g = -4; g <= 4; g++) { x.beginPath(); x.moveTo(cx + g * R / 4, 0); x.lineTo(cx + g * R / 4, h); x.stroke(); x.beginPath(); x.moveTo(0, cy + g * R / 4); x.lineTo(w, cy + g * R / 4); x.stroke(); }
      x.strokeStyle = '#b7bfca'; x.beginPath(); x.moveTo(cx, 0); x.lineTo(cx, h); x.moveTo(0, cy); x.lineTo(w, cy); x.stroke();
      x.setLineDash([2, 4]); x.strokeStyle = '#d3d9e0';
      [1 / 3, 2 / 3, 1].forEach(function (f) { x.beginPath(); x.arc(cx, cy, R * f, 0, 7); x.stroke(); });
      x.setLineDash([]);
      var col = { auto: '#f08a4b', float: '#e0a800', fixed: '#16a34a' }, now = performance.now();
      samples.forEach(function (p) {
        var px = cx + p.e / zoom * R, py = cy - p.n / zoom * R;
        if (px < -4 || px > w + 4 || py < -4 || py > h + 4) return;
        var age = (now - p.t) / 60000;
        x.globalAlpha = Math.max(.08, (p.s === state ? .85 : .35) * (1 - age));
        x.fillStyle = col[p.s]; x.beginPath(); x.arc(px, py, 1.6, 0, 7); x.fill();
      });
      x.globalAlpha = 1;
      if (state === 'fixed') { x.strokeStyle = 'rgba(22,163,74,.7)'; x.beginPath(); x.arc(cx, cy, R / 3, 0, 7); x.stroke(); }
      x.fillStyle = '#0b5d2a'; x.beginPath(); x.arc(cx, cy, 2.2, 0, 7); x.fill();
    }
    function drawSpark() {
      var x = P.x, w = P.w, h = P.h; x.clearRect(0, 0, w, h);
      if (rmsHist.length < 2) return;
      var lo = Math.log10(0.004), hi = Math.log10(3);
      x.strokeStyle = state === 'fixed' ? '#16a34a' : state === 'float' ? '#e0a800' : '#f08a4b'; x.lineWidth = 1.4; x.beginPath();
      rmsHist.forEach(function (v, i) {
        var px = w - (rmsHist.length - 1 - i) * (w / 59), py = h - 3 - (Math.log10(Math.max(v, 0.004)) - lo) / (hi - lo) * (h - 6);
        if (i === 0) x.moveTo(px, py); else x.lineTo(px, py);
      });
      x.stroke();
    }

    /* ---------- 主循环 ---------- */
    var running = false, tSample = 0, tSec = 0, tLast = 0;
    function utc(d) { return d.toISOString().substr(11, 8); }
    function frame(now) {
      if (!running) return;
      // 时序：第一个包到达 → FLOAT；约 4 s 后 → FIXED
      if (on && tFirst && state === 'auto') setState('float');
      if (on && state === 'float' && now - tFirst > 4000) setState('fixed');
      if (now - tSample > 200) { tSample = now; sample(now); }
      if (now - tSec > 1000) {
        tSec = now; var d = new Date(); q('utc').textContent = utc(d); q('clock').textContent = utc(d).substr(0, 5);
        var st = stats(); if (st) { q('rms').textContent = fmt(st.rms); q('cep50').textContent = fmt(st.c50); q('cep95').textContent = fmt(st.c95); rmsHist.push(st.rms); if (rmsHist.length > 60) rmsHist.shift(); }
        if (on && tFirst) { var age = (0.2 + Math.random() * 0.5).toFixed(1); q('page').textContent = age; q('age').textContent = age + ' s'; q('wage').textContent = age + ' s'; }
      }
      // 缩放按时间推进（对数空间，约 1.5 s 完成），帧率低时也不会拖慢
      var dt = Math.min(250, now - (tLast || now)); tLast = now;
      var lz = Math.log(zoom), lt = Math.log(zoomTo); lz += (lt - lz) * (1 - Math.exp(-dt / 380)); zoom = Math.abs(lz - lt) < .01 ? zoomTo : Math.exp(lz);
      q('range').textContent = zoom > 0.5 ? '±' + Math.round(zoom) + ' m' : '±' + Math.max(1, Math.round(zoom * 100)) + ' cm';
      drawFly(now); drawScatter(); drawSpark();
      requestAnimationFrame(frame);
    }
    function start() { if (running) return; running = true; tLast = 0; requestAnimationFrame(frame); }
    function stop() { running = false; }

    // 先铺一段 AUTONOMOUS 的历史点，进入时散点图不是空的
    (function seed() { var t = performance.now() - 20000; for (var i = 0; i < 100; i++) { var n0 = t + i * 200; var e = bias.e + gauss() * .8, n = bias.n + gauss() * .8; samples.push({ t: n0, e: e, n: n, s: 'auto' }); } })();
    sec.setAttribute('data-state', 'auto');

    if (reduce) {
      // 减少动态：直接给出收敛后的状态
      setOn(true); tFirst = performance.now() - 10000; setState('fixed'); zoom = zoomTo = .05;
      for (var i = 0; i < 150; i++) samples.push({ t: performance.now(), e: gauss() * .006, n: gauss() * .006, s: 'fixed' });
      var st = stats(); if (st) { q('rms').textContent = fmt(st.rms); q('cep50').textContent = fmt(st.c50); q('cep95').textContent = fmt(st.c95); }
      q('page').textContent = '0.2'; q('age').textContent = '0.2 s'; q('wage').textContent = '0.2 s';
      sample(performance.now()); drawScatter(); drawFly(performance.now());
      return;
    }
    KMX.onEnter(sec, function () { setTimeout(function () { if (!on) setOn(true); }, 1000); });
    KMX.onVisible(sec, function (v) { if (v) start(); else stop(); });
    if (!window.IntersectionObserver) start();
  }

  function boot() { document.querySelectorAll('.kmx-cor').forEach(initCorrect); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('.kmx-cor'); if (s) initCorrect(s); });
})();
